import { Injectable } from '@angular/core';
import { MiddlewareService } from './middleware.service';
import { apiURL } from '../../../assets/data/api-url';
import { ApiResponse } from '../enums/api-response.enum';
import { tap } from 'rxjs';
import { CompanyProfileData } from '../models/company-details.model';

@Injectable({
  providedIn: 'root'
})
export class BusinessCommonService {
  businessDetails!: CompanyProfileData;

  constructor(
    private _middlewareService: MiddlewareService
  ) { }

  setBusinessDetails(details: CompanyProfileData) {
    this.businessDetails = details;
  }

  getBusinessDetails() {
    return this.businessDetails;
  }

  getCompanyDetails(payload: any, organizationNumber: string, businessArrayIndex?: number) {
    return this._middlewareService
      .callPostMiddleware(`${apiURL.validateCommercialOrg}`, payload)
      .pipe(
        tap((response: any) => {
          if (response?.code === ApiResponse.OK) {
            let index;
            if (businessArrayIndex || businessArrayIndex === 0) {
              index = businessArrayIndex;
            } else {
              const arrayIndex = this.businessDetails?.companyRefs?.findIndex(item => item?.organizationNumber === organizationNumber);
              if (arrayIndex >= 0) {
                index = arrayIndex;
              }
            }
            this.businessDetails.companyRefs[index].organizationName = response?.result?.ExportCommercialOrganisation?.Name;
            this.businessDetails.companyRefs[index].businessType = response?.result?.ExportCommercialOrganisation?.BusinessType;
            this.businessDetails.companyRefs[index].expiryDate = response?.result?.ExportCommercialOrganisation?.ExpiryDate;
            this.businessDetails.companyRefs[index].nationalNumber = response?.result?.ExportCommercialOrganisation?.NationalNumber
            this.businessDetails.companyRefs[index].type = response?.result?.ExportCommercialOrganisation?.Type;
            this.businessDetails.companyRefs[index].blockedFlag = response?.result?.OutputParameters?.BlockedFlag;
            this.businessDetails.companyRefs[index].returnCode = response?.result?.OutputParameters?.ReturnCode;
            this.businessDetails.companyRefs[index].profileType = this.businessDetails?.profileType;
          }
        })
      );
  }

  checkCompanyEligibility(payload: any) {
    return this._middlewareService
      .callPostMiddleware(`${apiURL.sponsorValidationBussiness}`, payload)
      .pipe(
        tap((response: any) => {
          if (response?.code === ApiResponse.OK) {

          }
        })
      );
  }

  getUserDetailsFromDB() {
    return this._middlewareService
      .callGetMiddleware(apiURL.getCompanyUserDetails)
      .pipe(
        tap((response) => {
          if (response?.code === ApiResponse.OK) {
            this.businessDetails = response?.result;
            if (response?.result) {
              this.businessDetails.profileType = response?.result?.profileType;
              this.businessDetails.email = response?.result?.email;
              this.businessDetails.companyRefs = response?.result?.companyRefs?.map((ref: any) => {
                return {
                  blocked: ref?.blocked,
                  _id: ref?.company?._id,
                  organizationNumber: ref?.company?.organizationNumber,
                  businessType: ref?.company?.businessType,
                  errorMsg: ref?.company?.errorMsg,
                  expiryDate: ref?.company?.expiryDate,
                  organizationName: ref?.company?.organizationName,
                  type: ref?.company?.type,
                  blockedFlag: ref?.company?.blockedFlag,
                  nationalNumber: ref?.company?.nationalNumber,
                  returnCode: ref?.company?.returnCode,
                  profileType: response?.result?.profileType
                };
              })
            }
          }
        })
      );
  }

  createUserDetailsInDB(payload: any) {
    return this._middlewareService
      .callPostMiddleware(apiURL.createCompanyDetails, payload)
      .pipe(
        tap((response) => {
          if (response?.code === ApiResponse.OK) {

          }
        })
      );
  }

  transformCompanyDetailsForCreation() {
    const {
      _id,
      __v,
      createdAt,
      lastUpdated,
      updatedAt,
      ...cleanedRoot
    } = this.businessDetails;

    // Clean the companyRefs array
    cleanedRoot.companyRefs = cleanedRoot.companyRefs?.map((ref: any) => {
      const {
        _id,
        blocked,
        blockedFlag, // also remove this if needed
        email,
        commercialLoginPhoneNumberCountryCode,
        commercialLoginPhoneNumberValue,
        ...cleanedRef
      } = ref;
      return cleanedRef;
    });

    return cleanedRoot;
  }
}
